import { render, staticRenderFns } from "./ModalCadastroPortaria.vue?vue&type=template&id=d7b31fea"
import script from "./ModalCadastroPortaria.vue?vue&type=script&lang=js"
export * from "./ModalCadastroPortaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports